
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import CodeExample from 'nextra-theme-mui-docs/CodeExample';
import Basic from '../../examples/Sparkline/Basic';
import srcBasic from '../../examples/Sparkline/Basic?raw';
import Colors from '../../examples/Sparkline/Colors';
import srcColors from '../../examples/Sparkline/Colors?raw';
import Card from '../../examples/Sparkline/Card';
import srcCard from '../../examples/Sparkline/Card?raw';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "Sparkline.mdx",
    route: "/components/Sparkline",
    meta: {
      "title": "Sparkline"
    },
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"Sparkline"}</h1><p>{"A sparkline is a tiny chart that can be used to indicate a certain trend of a value."}</p><h2>{"Simple Sparkline"}</h2>{"\n"}<CodeExample src={srcBasic} mdxType="CodeExample"><Basic parentName="CodeExample" mdxType="Basic" /></CodeExample><h2>{"Color"}</h2><p>{"By default the sparkline has the primary color, but it can be customized as wanted."}</p>{"\n"}<CodeExample src={srcColors} mdxType="CodeExample"><Colors parentName="CodeExample" mdxType="Colors" /></CodeExample><h2>{"Examples"}</h2><p>{"Based on examples from the "}<a href="https://material.io/design/communication/data-visualization.html#style" parentName="p">{"Material Design documentation"}</a>{"."}</p>{"\n"}<CodeExample src={srcCard} mdxType="CodeExample"><Card parentName="CodeExample" mdxType="Card" /></CodeExample></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
